import {createSlice} from "@reduxjs/toolkit";
import {generateFakeActivityLogs} from "../../data/logs";

const activityLogs = generateFakeActivityLogs();

const LogsSlice:any = createSlice({
    name: "logsData",
    initialState: {
        activityLogs
    },
    reducers: {
        regenerateData(state) {
            state.activityLogs = generateFakeActivityLogs();
        }
    }
});

export const { regenerateData } = LogsSlice.actions;
export default LogsSlice.reducer;
